import { MantraTriLanguageBlock } from "@/components/i18n/TriLanguageBlock";
import { hasSanskritContent, normalizeTriLanguageItem } from "@/lib/i18n/tri-language";

/**
 * Render mantra/Sanskrit content via the global tri-language engine (+ audio on Sādhanā).
 */
export function renderMantraText(textOrItem, { className = "", token, textClassName = "", compact, meaningPrefix = "translation" } = {}) {
  if (textOrItem === null || textOrItem === undefined || textOrItem === "") return null;

  const item =
    typeof textOrItem === "string"
      ? normalizeTriLanguageItem({ text: textOrItem })
      : normalizeTriLanguageItem(textOrItem);

  if (!hasSanskritContent(item)) {
    const plain = typeof textOrItem === "string" ? textOrItem : item.translation_en || item.meaning || "";
    if (!plain) return null;
    return <span className={className}>{plain}</span>;
  }

  return (
    <MantraTriLanguageBlock
      item={item}
      token={token}
      className={className}
      textClassName={textClassName}
      compact={compact}
      meaningPrefix={meaningPrefix}
    />
  );
}
